import React from 'react';
import AboutGame from '../components/AboutGame';
// import GameCard from '../components/GameCard';
// import BankCards from '../components/BankCards';
// import TeamComposition from '../components/TeamComposition';
// import Stages from '../components/Stages';
import Banner from "../components/Banner"; // Import Banner component
import bannerImage from "../images/game.jpeg"; // Import the image correctly

const AboutGamePage = () => {
  
  return (
    <div>
      {/* Banner Section */}
      <Banner 
        bannerImage={bannerImage} 
        title="About the Game" 
        style={{ 
          backgroundImage: `url(${bannerImage})`, 
          backgroundSize: 'cover', 
          backgroundPosition: 'center', 
          height: '400px', // Adjust as needed
          color: 'white', 
          textAlign: 'center', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }} 
      />
    
      {/* About Game Page Content */}
      <AboutGame />
      {/* <GameCard /> */}
      {/* <BankCards />
      <TeamComposition />
      <Stages /> */}
    </div>
  );
};

export default AboutGamePage;
